export enum ProjectTypeEnum {
    Admin = 1,
    Website = 2,
}
